export async function getWebContent(formdata) {
  const requestOptions = {
    method: "POST",
    headers: {},
    body: formdata,
    redirect: "follow",
  };

  const origin = `${window.location.origin}/web/content`;
  const response = await fetch(origin, requestOptions).then(
    (response) => response
  );

  return response;
}
